module.exports = __webpack_public_path__ + "static/Background-mp-3.03d531ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-mp-3.jpg
// module id = 113
// module chunks = 133428282160390 225901961288281